export default "__VITE_ASSET__DkDTiq4M__"